
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { comic } from '@mdx-deck/themes'

export const theme = comic;

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* deck.mdx */
    }


    <h1>{`GitHub Bootcamp`}</h1>
    <hr></hr>
    <h2>{`This is my deck`}</h2>
    <hr></hr>
    <h2>{`Happy Hacking`}</h2>
    <hr></hr>
    <h2>{`Create a new repository`}</h2>
    <hr></hr>
    <h2>{`Review changes`}</h2>
    <p><inlineCode parentName="p">{`gss`}</inlineCode></p>
    <hr></hr>
    <h2>{`Commit changes`}</h2>
    <pre><code parentName="pre" {...{}}>{`ga file.txt
gcam "super message"
`}</code></pre>
    <hr></hr>
    <h2>{`Create a new branch`}</h2>
    <p><inlineCode parentName="p">{`gb a_new_branch`}</inlineCode></p>
    <hr></hr>
    <h2>{`Work on a branch`}</h2>
    <p><inlineCode parentName="p">{`gco a_new_branch`}</inlineCode></p>
    <p>{`ou`}</p>
    <p><inlineCode parentName="p">{`gcb a_new_branch`}</inlineCode>{`
pour créer + checkout`}</p>
    <hr></hr>
    <h2>{`Merge branch on `}<inlineCode parentName="h2">{`main`}</inlineCode></h2>
    <pre><code parentName="pre" {...{}}>{`gcm
gm a_new_branch\`
`}</code></pre>
    <hr></hr>
    <h2>{`Delete a branch`}</h2>
    <p><inlineCode parentName="p">{`gprune`}</inlineCode></p>
    <hr></hr>
    <h2>{`Pushing changes to remote`}</h2>
    <p><inlineCode parentName="p">{`gp`}</inlineCode></p>
    <hr></hr>
    <h2>{`Pulling changes from remote`}</h2>
    <p><inlineCode parentName="p">{`gl`}</inlineCode></p>
    <hr></hr>
    <h2>{`Text`}</h2>
    <p>{`Some text`}</p>
    <hr></hr>
    <h2>{`Lists`}</h2>
    <pre><code parentName="pre" {...{}}>{`* unordered list
* unordered list
`}</code></pre>
    <ul>
      <li parentName="ul">{`unordered list`}</li>
      <li parentName="ul">{`unordered list`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`1. ordered list
1. ordered list
`}</code></pre>
    <ol>
      <li parentName="ol">{`ordered list`}</li>
      <li parentName="ol">{`ordered list`}</li>
    </ol>
    <hr></hr>
    <h2>{`Lists`}</h2>
    <pre><code parentName="pre" {...{}}>{`- nested lists
  - nested list: 2 spaces
  - nested list
- nested list
  - nested list
`}</code></pre>
    <ul>
      <li parentName="ul">{`nested lists`}
        <ul parentName="li">
          <li parentName="ul">{`nested list: 2 spaces`}</li>
          <li parentName="ul">{`nested list`}</li>
        </ul>
      </li>
      <li parentName="ul">{`nested list`}
        <ul parentName="li">
          <li parentName="ul">{`nested list`}</li>
        </ul>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Image`}</h2>
    <pre><code parentName="pre" {...{}}>{`![this image](url)
`}</code></pre>
    <img {...{
      "src": "https://octodex.github.com/images/yaktocat.png",
      "alt": "Image of Yaktocat"
    }}></img>
    <hr></hr>
    <h2>{`Headers and quotes`}</h2>
    <pre><code parentName="pre" {...{}}>{`# level 1
## level 2
### level 3
`}</code></pre>
    <h1>{`level 1`}</h1>
    <h2>{`level 2`}</h2>
    <h3>{`level 3`}</h3>
    <pre><code parentName="pre" {...{}}>{`Some quote

> quote
> quote
`}</code></pre>
    <hr></hr>
    <h2>{`Code`}</h2>
    <pre><code parentName="pre" {...{}}>{`inline code: \`code\`

block code:

\`\` \`\`\` \`\` language
only 3 backticks
more code
\`\` \`\`\` \`\`

`}</code></pre>
    <p>{`inline code: `}<inlineCode parentName="p">{`code`}</inlineCode></p>
    <p>{`block code:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`some code
more code
`}</code></pre>
    <hr></hr>
    <h2>{`extras`}</h2>
    <pre><code parentName="pre" {...{}}>{`- [ ] incomplete item
- [x] complete item
`}</code></pre>
    <ul {...{
      "className": "contains-task-list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`incomplete item`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": true,
          "disabled": true
        }}></input>{` `}{`complete item`}</li>
    </ul>
    <hr></hr>
    <h2>{`github automation`}</h2>
    <p>{`add `}<inlineCode parentName="p">{`issue_template.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`pull_request.md`}</inlineCode>{` files`}</p>
    <p><a parentName="p" {...{
        "href": "https://docs.github.com/en/communities/using-templates-to-encourage-useful-issues-and-pull-requests/configuring-issue-templates-for-your-repository#creating-issue-forms"
      }}>{`https://docs.github.com/en/communities/using-templates-to-encourage-useful-issues-and-pull-requests/configuring-issue-templates-for-your-repository#creating-issue-forms`}</a></p>
    <hr></hr>
    <h2>{`How to apply commit`}</h2>
    <pre><code parentName="pre" {...{}}>{`git cherry-pick SHA
`}</code></pre>
    <pre><code parentName="pre" {...{}}>{`gcp SHA
`}</code></pre>
    <hr></hr>
    <h2>{`How to use git fragments`}</h2>
    <p>{`Créer un fragment`}</p>
    <pre><code parentName="pre" {...{}}>{`gsta
git stash
git stash push
`}</code></pre>
    <p>{`Appliquer le dernier fragment`}</p>
    <pre><code parentName="pre" {...{}}>{`gstp
git stash pop
`}</code></pre>
    <hr></hr>
    <h2>{`this one will be reverted`}</h2>
    <pre><code parentName="pre" {...{}}>{`git revert <SHA1>
`}</code></pre>
    <hr></hr>
    <h2>{`How to fix the last commit message`}</h2>
    <pre><code parentName="pre" {...{}}>{`git commit --amend
git commit --amend -m "Fixes bug #42"
gc!
`}</code></pre>
    <hr></hr>
    <h2>{`Cancel changes`}</h2>
    <p>{`cancel commit and keeping changes`}</p>
    <pre><code parentName="pre" {...{}}>{`git reset SHA
grh SHA

`}</code></pre>
    <p>{`cancel commit and delete changes`}</p>
    <pre><code parentName="pre" {...{}}>{`git reset --hard SHA
grhh SHA

`}</code></pre>
    <hr></hr>
    <h2>{`How to rebase like a boss`}</h2>
    <pre><code parentName="pre" {...{}}>{`grbi <earlier SHA>
git rebase -i <earlier SHA>
`}</code></pre>
    <p><strong parentName="p">{`What’s happening`}</strong>{`: `}<inlineCode parentName="p">{`-i`}</inlineCode>{` puts rebase in “interactive mode”. It starts off like the rebase discussed above, but before replaying any commits, it pauses and allows you to gently modify each commit as it’s replayed.`}</p>
    <p>{`## How to deal with conflicts`}</p>
    <p>{`Let's generate some conflicts`}</p>
    <p>{`blabla`}</p>
    <hr></hr>
    <pre><code parentName="pre" {...{}}>{`  Quentin Grimonprez
`}</code></pre>
    <img {...{
      "src": "https://raw.githubusercontent.com/flexbox/github-bootcamp/main/slides/github-bootcamp.png",
      "alt": null
    }}></img>
    <hr></hr>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;